import { createSignal, onCleanup } from 'solid-js'

export type CountdownParts = {
  days: number
  hours: number
  minutes: number
  seconds: number
  totalSeconds: number
  isExpired: boolean
}

export function splitSeconds(seconds: number) {
  const total = Math.max(0, Math.floor(seconds))
  return {
    day: Math.floor(total / 86400),
    hour: Math.floor((total % 86400) / 3600),
    min: Math.floor((total % 3600) / 60),
    sec: total % 60,
  }
}

function partsFrom(targetMs: number): CountdownParts {
  const now = Date.now()
  const totalMs = Math.max(0, targetMs - now)
  const totalSeconds = Math.floor(totalMs / 1000)
  const days = Math.floor(totalSeconds / 86400)
  const hours = Math.floor((totalSeconds % 86400) / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60
  return {
    days,
    hours,
    minutes,
    seconds,
    totalSeconds,
    isExpired: totalMs <= 0,
  }
}

// A per-second "now" signal, for logic that switches on wall-clock windows
// (not just a single countdown target).
export function createNow(intervalMs = 1000) {
  const [now, setNow] = createSignal(Date.now())
  const id = window.setInterval(() => setNow(Date.now()), intervalMs)
  onCleanup(() => window.clearInterval(id))
  return now
}

export function createCountdown(targetIso: () => string | null | undefined) {
  const [parts, setParts] = createSignal<CountdownParts>(
    partsFrom(targetIso() ? new Date(targetIso()!).getTime() : 0),
  )

  const tick = () => {
    const iso = targetIso()
    if (!iso) {
      setParts(partsFrom(0))
      return
    }
    setParts(partsFrom(new Date(iso).getTime()))
  }
  tick()

  const id = window.setInterval(tick, 1000)
  onCleanup(() => window.clearInterval(id))

  return parts
}
